<template>
    <div>
        <h1 style="font-size: 24px; color: black;">月报</h1>
        <el-card shadow="never">
            <el-row type="flex">
                <el-col>
                    <span> 产品分类</span>
                    <el-select v-model="dept" placeholder="请选择" @change="deptChange">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(value,key) in deptObj"
                                   :key="key"
                                   :label="value"
                                   :value="key"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 应用：</span>
                    <el-select v-model="queryData.packageName" placeholder="请选择" filterable collapse-tags multiple
                               @change="change">
                        <el-option v-for="app in appList"
                                   :key="app.packageName"
                                   :label="app.appName"
                                   :value="app.packageName"></el-option>
                    </el-select>
                </el-col>
                <el-col>
                    <span> 日期</span>
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00','23:59:59']"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <el-button type="primary" @click="clear">清空</el-button>
                    <el-button type="primary" @click="search">查询</el-button>
                </el-col>
            </el-row>
        </el-card>

        <div class="table-wrapper">

            <h1 v-if="t===2||t===1">月数据</h1>
            <el-table v-if="t===2||t===1" :data="datas" border :fit="true" :key="21" @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日roi" prop="roi208_daily"></el-table-column>
                <el-table-column label="roi同比" prop="roi208_daily_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi208_daily_tb)">{{ scope.row.roi208_daily_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="收入" prop="money_all"></el-table-column>
                <el-table-column label="毛利" prop="ml"></el-table-column>
                <el-table-column label="运营roi" prop="roi"></el-table-column>
                <el-table-column label="新增" prop="rn_all1"></el-table-column>
                <el-table-column label="新增同比" prop="rn_all1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.rn_all1_tb)">{{ scope.row.rn_all1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa208"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa208_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa208_tb)">{{ scope.row.cpa208_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="次留" prop="208_r1"></el-table-column>
                <el-table-column label="次留同比" prop="208_r1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row['208_r1_tb'])">{{ scope.row['208_r1_tb'] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="arpu" prop="arpu_week208"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm208"></el-table-column>
                <el-table-column label="ipu" prop="ipu208"></el-table-column>
                <el-table-column label="活跃" prop="umactive_of"></el-table-column>
                <el-table-column label="有价新增占比" prop="yjxz_rate"></el-table-column>
                <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                <el-table-column label="arpu" prop="arpu_day"></el-table-column>
            </el-table>

            <h1 v-if="t===2||t===1">分媒体数据</h1>
            <el-table v-if="t===2||t===1" :data="datasWeeklyPlatform" border :fit="true" :key="22"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="媒体名称" prop="platform"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日roi" prop="roi208"></el-table-column>
                <el-table-column label="roi同比" prop="roi208_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi208_tb)">{{ scope.row.roi208_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="新增" prop="rn1"></el-table-column>
                <el-table-column label="新增同比" prop="rn1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.rn1_tb)">{{ scope.row.rn1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa_mt"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa_mt_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa_mt_tb)">{{ scope.row.cpa_mt_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="次留" prop="ml_r1_xxl"></el-table-column>
                <el-table-column label="次留同比" prop="ml_r1_xxl_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.ml_r1_xxl_tb)">{{ scope.row.ml_r1_xxl_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="arpu" prop="arpu_week_mt"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm_mt"></el-table-column>
                <el-table-column label="ipu" prop="ipu_mt"></el-table-column>
            </el-table>

            <h1 v-if="t===2">分产品</h1>
            <el-table v-if="t===2" :data="datasWeekly" border :fit="true" :key="23"
                      @sort-change='sortChange'>
                <el-table-column key="4" label="产品" prop="package_name"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="总新增" prop="rn_all1"></el-table-column>
                <el-table-column label="cpa" prop="cpa208"></el-table-column>
                <el-table-column label="arpu" prop="arpu_week208"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm208"></el-table-column>
                <el-table-column label="ipu" prop="ipu208"></el-table-column>
                <el-table-column label="首日roi" prop="roi208_daily"></el-table-column>
            </el-table>

            <h1 v-if="t===2">分日数据</h1>
            <el-table v-if="t===2" :data="datasWeeklyDaily" border :fit="true" :key="24"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="星期" prop="week"></el-table-column>
                <el-table-column label="总新增" prop="rn_all1"></el-table-column>
                <el-table-column label="cpa" prop="cpa208"></el-table-column>
                <el-table-column label="留存" prop="208_r1"></el-table-column>
                <el-table-column label="arpu" prop="arpu_week208"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm208"></el-table-column>
                <el-table-column label="ipu" prop="ipu208"></el-table-column>
                <el-table-column label="首日roi" prop="roi208_daily"></el-table-column>
            </el-table>

            <h1 v-if="t===3">运营口径</h1>
            <el-table v-if="t===3" :data="datas" border :fit="true" :key="31" @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总收益" prop="money_all"></el-table-column>
                <el-table-column label="毛利" prop="ml"></el-table-column>
                <el-table-column label="运营roi" prop="roi"></el-table-column>
                <el-table-column label="roi同比" prop="roi_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi_tb)">{{ scope.row.roi_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="新增" prop="umnew"></el-table-column>
                <el-table-column label="新增同比" prop="umnew_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.umnew_tb)">{{ scope.row.umnew_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa_tb)">{{ scope.row.cpa_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="次留" prop="ql_r1"></el-table-column>
                <el-table-column label="次留同比" prop="ql_r1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.ql_r1_tb)">{{ scope.row.ql_r1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="活跃" prop="umactive_of"></el-table-column>
                <el-table-column label="总ecpm" prop="ecpm_la"></el-table-column>
                <el-table-column label="总ipu" prop="ipu_la"></el-table-column>
                <el-table-column label="arpu" prop="arpu_day"></el-table-column>
            </el-table>

            <h1 v-if="t===3">增长口径</h1>
            <el-table v-if="t===3" :data="datasWeeklyGro" border :fit="true" :key="32" @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日roi" prop="roi208"></el-table-column>
                <el-table-column label="roi同比" prop="roi208_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi208_tb)">{{ scope.row.roi208_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="新增" prop="umnew"></el-table-column>
                <el-table-column label="新增同比" prop="umnew_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.umnew_tb)">{{ scope.row.umnew_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa_tb)">{{ scope.row.cpa_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="次留" prop="ql_r1"></el-table-column>
                <el-table-column label="次留同比" prop="ql_r1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.ql_r1_tb)">{{ scope.row.ql_r1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="arpu" prop="arpu_week"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm"></el-table-column>
                <el-table-column label="ipu" prop="ipu"></el-table-column>
            </el-table>

            <h1 v-if="t===3">分媒体数据</h1>
            <el-table v-if="t===3" :data="datasWeeklyPlatform" border :fit="true" :key="33"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="媒体名称" prop="platform"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日roi" prop="roi208"></el-table-column>
                <el-table-column label="roi同比" prop="roi208_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi208_tb)">{{ scope.row.roi208_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="新增" prop="rn1"></el-table-column>
                <el-table-column label="新增同比" prop="rn1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.rn1_tb)">{{ scope.row.rn1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa_mt"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa_mt_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa_mt_tb)">{{ scope.row.cpa_mt_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="次留" prop="ml_r1"></el-table-column>
                <el-table-column label="次留同比" prop="ml_r1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.ml_r1_tb)">{{ scope.row.ml_r1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="arpu" prop="arpu_week_mt"></el-table-column>
                <el-table-column label="ecpm" prop="ecpm_mt"></el-table-column>
                <el-table-column label="ipu" prop="ipu_mt"></el-table-column>
            </el-table>

            <h1 v-if="t===4">运营口径</h1>
            <el-table v-if="t===4" :data="datas" border :fit="true" :key="41" @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总收益" prop="money_all"></el-table-column>
                <el-table-column label="毛利" prop="ml"></el-table-column>
                <el-table-column label="收益同比" prop="money_all_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.money_all_tb)">{{ scope.row.money_all_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="月roi" prop="roi"></el-table-column>
                <el-table-column label="总新增" prop="umnew"></el-table-column>
                <el-table-column label="新增同比" prop="umnew_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.umnew_tb)">{{ scope.row.umnew_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa"></el-table-column>
                <el-table-column label="留存" prop="ql_r1"></el-table-column>
            </el-table>

            <h1 v-if="t===4">分渠道数据</h1>
            <el-table v-if="t===4" :data="datasWeeklyPlatform" border :fit="true" :key="42"
                      @sort-change='sortChange'>
                <el-table-column label="日期" prop="dt"></el-table-column>
                <el-table-column label="媒体名称" prop="platform"></el-table-column>
                <el-table-column label="总消耗" prop="charge"></el-table-column>
                <el-table-column label="消耗同比" prop="charge_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.charge_tb)">{{ scope.row.charge_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="新增" prop="rn1"></el-table-column>
                <el-table-column label="新增同比" prop="rn1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.rn1_tb)">{{ scope.row.rn1_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="cpa" prop="cpa_mt"></el-table-column>
                <el-table-column label="cpa同比" prop="cpa_mt_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.cpa_mt_tb)">{{ scope.row.cpa_mt_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日收益" prop="money_all_mt"></el-table-column>
                <el-table-column label="收益同比" prop="money_all_mt_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.money_all_mt_tb)">{{ scope.row.money_all_mt_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首日roi" prop="roi208"></el-table-column>
                <el-table-column label="首日roi同比" prop="roi208_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.roi208_tb)">{{ scope.row.roi208_tb }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="留存" prop="ml_r1"></el-table-column>
                <el-table-column label="留存同比" prop="ml_r1_tb">
                    <template slot-scope="scope">
                        <span :class="tbColor(scope.row.ml_r1_tb)">{{ scope.row.ml_r1_tb }}</span>
                    </template>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>
import {reportDaily} from "@/http/outApi";
import settingMix from "@/utils/mix/common-setting";
import utils from "@/utils";

export default {
    name: "ReportMonthly",
    mixins: [settingMix],
    data() {
        return {
            appList: [],
            needGetApp: true,
            checkAll: false,
            headers: {},
            datas: [],
            dept: null,
            datasWeeklyPlatform: [],
            needDept: true,
            deptObj: {},
            datasWeekly: [],
            datasWeeklyDaily: [],
            datasWeeklyGro: [],
            queryData: {
                timeDate: ['', '']
            },
            t: 1
        }
    },
    methods: {
        tbColor(val) {
            if (!val) return ''
            let num = parseFloat(val.toString().replace(/%/g, ''))
            if (isNaN(num)) return ''
            if (num < 0) return 'text-red'
            if (num > 0) return 'text-blue'
            return ''
        },
        change() {
            for (var x in this.appList) {
                var app = this.appList[x];
                if (app.packageName === this.queryData.packageName[0]) {
                    // 2 208
                    // 3 猫狗 小游戏 新项目
                    // 4 记账 暖悦
                    var systemVersion = app.systemVersion;
                    var dept = app.dept;
                    if (dept === 2 || dept === 5) {
                        this.t = 4;
                    } else if (dept === 3 || dept === 4 || dept === 6) {
                        this.t = 3;
                    } else if (dept === 1) {
                        this.t = 2;
                    } else {
                        this.t = 1;
                    }
                    if (this.dept === '') {
                        this.t = 1;
                    }
                    this.search();
                    return;
                }
            }
        },
        search() {
            if (this.queryData.timeDate === null) {
                this.queryData.timeDate = ['', ''];
            }
            this.queryData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            this.queryData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            this.queryData.excel = false;
            this.queryData.level = "month";
            reportDaily(this.queryData).then(resp => {
                this.datas = resp.data.info.content;
                this.datasWeeklyPlatform = resp.data.info.contentWeeklyPlatform;
                this.datasWeekly = resp.data.info.contentWeekly;
                this.datasWeeklyDaily = resp.data.info.contentWeeklyDaily;
                this.datasWeeklyGro = resp.data.info.contentWeeklyGro;
            })
        },
        sortChange(order) {
            this.queryData.order = order.order;
            this.queryData.prop = order.prop;
            this.search();
        },
        deptChange() {
            var list = [];
            for (var x in this.appList) {
                if (this.appList[x].dept + "" === this.dept + "" || this.dept === '') {
                    list.push(this.appList[x].packageName)
                }
            }
            this.queryData.packageName = list;
            this.change();
        },
        clear() {
            this.dept = null;
            this.queryData.packageName = [];
        },
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.queryData.timeDate = [utils.TodayUtil.getToday(), utils.TodayUtil.getToday()];
    },
    mounted() {
        this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    }
}
</script>

<style scoped>
.text-red {
    color: red;
}

.text-blue {
    color: #1890ff;
}

.table-wrapper {
    overflow: visible;
}
</style>